export class HttpStatusCode{
  public static Unauthorized: number = 401;
  public static Forbidden: number = 403;
  public static Conflict: number = 409;
  public static NotFound: number = 404;
  public static Ok: number = 200;
  public static BadRequest: number = 400;
}
